const CONFIG = {

  //
  // Analytics
  //
  analytics: {
    // Google Analytics
    // Don't change the id, we are always tracking internally
    // to Integration Marketing Account
    // Change the category according to the name of
    // your project
    // In case you need GA uncomment the lines for properties id and category
    ga: {
      id: 'UA-12310597-137',
      category: '[AC-17830] TH-US | Lunchables BTS Q3 2020 - Colouring Contest Custom Destination'
    },
  },

  //
  // Images Preloader & Subsequent loader
  //
  images: {
    preload: [
      'images/background.png',
      'images/logo.png',
      'images/reskin-pattern.svg',
      'images/mobile.png',
      'images/footer_rules.png',
      'images/footer_rules-hover.png'
    ],
    subsequent: [
      'images/rules_close.png',
      'images/popup.png'
    ]
  },

  //
  // Settings for our app
  //
  settings: {

    date: null,

    // MINUTES to MILLISECONDS
    timeout: (15 * 60000),

    closed: {
      voteBetween: 'SEPTEMBER 26<span class="sub">TH</span> -<br>SEPTEMBER 29<span class="sub">TH</span>',
      winnerAnnounced: '1<span class="sub">st</span> WEEK OF<br>OCTOBER'
    },

    competition: {
      voteBetween: 'SEPTEMBER 26<span class="sub">TH</span> -<br>SEPTEMBER 29<span class="sub">TH</span>'
    },

    voting: {
      winnerAnnounced: '1<span class="sub">st</span> WEEK OF OCTOBER'
    },

    exits: {
      lunchables: 'https://www.lunchables.com/',
      termsofservice: 'https://www.totallyhermedia.com/terms-service/',
      privacypolicy: 'https://www.totallyhermedia.com/privacy',
      contact: 'mailto:contact@totallykidz.com'
    },

    dates: {
      contest: {
        startDate: null,
        endDate: new Date('09/21/2020 23:59:59')
      },
      contestclosed: {
        startDate: new Date('09/22/2020 00:00:00'),
        endDate: new Date('09/25/2020 23:59:59')
      },
      voting: {
        startDate: new Date('09/26/2020 00:00:00'),
        endDate: new Date('09/29/2020 23:59:59')
      },
      votingclosed: {
        startDate: new Date('09/30/2020 00:00:00'),
        endDate: new Date('10/06/2020 23:59:59')
      },
      winner: {
        startDate: new Date('10/07/2020 00:00:00'),
        endDate: null
      }
    },

    mask: {
      toolbar: {
        stickers: [
          'images/sticker1.png',
          'images/sticker2.png',
          'images/sticker3.png',
          'images/sticker4.png',
          'images/sticker5.png',
          'images/sticker6.png'
        ],
        palette: [
          '#237100', '#5e9d3e', '#fce239', '#ef860b',
          '#3a43f2', '#4faaff', '#ff85ec', '#ed1c24',
          '#8746e1', '#9c9c9c', '#000000', '#ffffff'
        ],
        brushSizes: [9, 12, 17, 26]
      },
      topLayer: 'images/mask-design_mask.png'
    },

    sweepstake: {
      hash: 'n0e'
    },

    vote: [
      {
        id: 40,
        image: 'images/vote_temp-mask_1.png',
        name: 'mask1'
      },
      {
        id: 41,
        image: 'images/vote_temp-mask_2.png',
        name: 'mask2'
      },
      {
        id: 42,
        image: 'images/vote_temp-mask_3.png',
        name: 'mask3'
      },
      {
        id: 43,
        image: 'images/vote_temp-mask_4.png',
        name: 'mask4'
      },
      {
        id: 44,
        image: 'images/vote_temp-mask_5.png',
        name: 'mask5'
      }
    ],

    poll: {
      id: 10
    }
  }
};

export default CONFIG;
